import { onError } from '@apollo/client/link/error';

import type { ApolloErrorInfo } from '../DatadogRumProvider/types';
import { useDatadogRum } from '../DatadogRumProvider/useDatadogRum';
import { useServerLogger } from '../ServerLogProvider';

export const useErrorLink = () => {
  const { logError } = useDatadogRum();
  const serverLogger = useServerLogger();
  const isDatadogSynthetics = (userAgent: string | undefined): boolean =>
    userAgent?.endsWith('DatadogSynthetics') ?? false;

  const errorLink = onError(
    ({ graphQLErrors, networkError, operation, response, protocolErrors }) => {
      const xRequestId = operation.getContext().headers?.['x-request-id'];
      const isSyntheticRequest = isDatadogSynthetics(
        navigator?.userAgent ?? '',
      );
      const { operationName } = operation;
      const errorMessage = `An error occurred during the GraphQL operation: ${operationName}`;
      const logContext: ApolloErrorInfo = {
        xRequestId,
        isSyntheticRequest,
        graphQLErrors: graphQLErrors ? [...graphQLErrors] : undefined,
        networkError,
        operation,
        response,
        protocolErrors: protocolErrors ? [...protocolErrors] : undefined,
      };

      serverLogger?.error(
        { activity: operationName, error: logContext },
        errorMessage,
      );

      if (logError) {
        logError(new Error(errorMessage), {
          apolloErrorInfo: logContext,
        });
      }
    },
  );

  return errorLink;
};
